import React from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../i18n/dateLocale";

const NotificationTable = (props) => {
  const { t } = useTranslation();

  return (
    <div className="table-wrapper px-3 pt-3">
      <p className="table-type">{t("admin.notifications.table.allType", { type: props?.type })}</p>
      <div className="table-wrapper-scroll-y table-scrollbar">
        <div className="table-own table-responsive">
          <table className="table table-striped table-hover table-admin">
            <thead className="table-head">
              <tr>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "storeName" ? "active" : ""
                    } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                // onClick={() => props.arraySorting("storeName")}
                >
                  <span>{t("common.title")}</span>{" "}
                  {props?.sortObj?.sortType === "aesc" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th>
                  <span>{props?.type === "template" ? t("common.name") : t("admin.notifications.table.count")}</span>
                </th>
                {/* <th>
                  <span>Summary</span>
                </th> */}
                <th>
                  <span>{t("common.created")}</span>
                </th>
                {props?.type === "template" ? (
                  <>
                    <th className="text-center" style={{ width: "200px" }}>
                      <span>{t("admin.notifications.table.viewTemplate")}</span>
                    </th>

                    <th style={{ width: "100px" }}>
                      <span>{t("common.action")}</span>
                    </th>
                  </>
                ) : (
                  <th style={{ width: "100px" }}>
                    <span>{t("common.action")}</span>
                  </th>
                )}
              </tr>
            </thead>
            <tbody className="table-body">
              {props.dataList.map((data) => {
                return (
                  <tr
                    key={
                      data?.notificationTemplateId || data?.notificationReportId
                    }
                  >
                    <td style={{ overflowWrap: "anywhere", maxWidth: "500px" }}>
                      {data?.title || "N/A"}
                    </td>
                    <td>
                      {props?.type === "template"
                        ? data?.name || "N/A"
                        : data?.usersCount || "N/A"}
                    </td>
                    {/* <td>{ReactHtmlParser(data?.body) || "N/A"}</td> */}
                    <td>
                      {data.created
                        ? formatDate(new Date(data?.created))
                        : "NA"}
                    </td>

                    {props?.type === "template" ? (
                      <>
                        <td className="table-data-status text-center">
                          <button
                            onClick={() => props.sendNotification(data)}
                            className="btn btn-own-admin secondary-btn btn-sm-own table-action"
                          >
                            {t("common.view")}
                          </button>
                        </td>

                        <td className="nowrap">
                          <span
                            className="btn btn-own-admin primary-btn btn-sm-own table-action"
                            onClick={() => props.deleteData(data)}
                          >
                            {t("common.delete")}
                          </span>
                        </td>
                      </>
                    ) : (
                      <td className="nowrap">
                        <span
                          className="btn btn-own-admin secondary-btn btn-sm-own table-action"
                          onClick={() => props.viewNotification(data)}
                        >
                          {t("common.view")}
                        </span> | <span
                          className="btn btn-own-admin primary-btn btn-sm-own table-action"
                          onClick={() => props.deleteData(data)}
                        >
                          {t("common.delete")}
                        </span>

                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default NotificationTable;
